<template>
  <div id="workflow">
    <v-container fluid grid-list-xl pa-0>
      <!-- image -->
      <v-layout align-center justify-center row v-if="workflowRecords" wrap>
        <v-flex pa-0 sm6 xs12>
          <v-img :aspect-ratio="16 / 9" :src="workflowRecords.picture"></v-img>
        </v-flex>
      </v-layout>
      <!-- product -->
      <base-product-header></base-product-header>

      <!-- Workflow Record -->
      <v-layout align-center justify-center row v-if="workflowRecords" wrap>
        <v-flex py-0 sm6 xs11>
          <div class="headline font-weight-bold">{{ workflowRecords.title }}</div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 xs11>
          <base-raw-data class="font-THSarabunNew"></base-raw-data>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex mb-2 sm6 xs11>
          <div class="font-THSarabunNew">{{ workflowRecords.description || '' }}</div>
        </v-flex>
      </v-layout>

      <!-- image -->
      <!-- <v-layout align-center justify-center row v-if="workflowRecords" wrap>
        <v-flex pa-0 sm6 xs12>
          <v-parallax height="200" :src="workflowRecords.picture"></v-parallax>
        </v-flex>
      </v-layout>-->

      <div :key="`group-${workflowGroup.workflowGroupId}`" v-for="workflowGroup in workflowGroups">
        <!-- Workflow Group -->
        <v-layout align-center justify-center row wrap>
          <v-flex pt-0 px-0 sm6 text-xs-center xs12>
            <v-card color="green" dark elevation="0" style="border-radius: 0px">
              <div class="caption spacing pa-2">{{ workflowGroup.workflowGroupName }}</div>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- Workflow Sub -->
        <v-layout
          align-center
          justify-center
          :key="`sub-${workflowSub.workflowSubId}`"
          row
          v-for="workflowSub in workflowSubs"
          wrap
        >
          <v-flex mb-4 sm6 v-if="workflowGroup.workflowGroupId == workflowSub.workflowGroupId" xs11>
            <div class="title font-weight-bold pb-2">{{ workflowSub.workflowSubName }}</div>
            <!-- Workflow Sub -->
            <v-layout
              align-center
              :key="workflowGroupOne.idx"
              row
              v-for="workflowGroupOne in workflowGroupOne"
              wrap
            >
              <div v-if="workflowSub.workflowSubId == workflowGroupOne.workflowSubId">
                <!-- Without Sequence -->
                <v-flex
                  class="font-THSarabunNew"
                  py-0
                  v-if="workflowGroupOne.tips == 0 && !workflowGroupOne.sequence"
                  xs12
                  >{{ workflowGroupOne.description }}</v-flex
                >
                <!-- With Sequence -->
                <v-flex
                  class="font-THSarabunNew"
                  py-0
                  v-else-if="workflowGroupOne.tips == 0 && workflowGroupOne.sequence"
                  xs12
                  >{{ workflowGroupOne.sequence }}. {{ workflowGroupOne.description }}</v-flex
                >
                <!-- Tips Card -->
                <v-flex v-else xs12>
                  <v-card class="card-tips" color="yellow lighten-5" elevation="0">
                    <v-card-text class="px-4 py-2">
                      <div class="subheading card-title">
                        <v-icon
                          class="mr-2"
                          color="amber lighten-1"
                          small
                          style="vertical-align:middle"
                          >star</v-icon
                        >เทคนิค
                      </div>

                      <div class="font-THSarabunNew mt-2" style="font-size:18px;">
                        {{ workflowGroupOne.description }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex class="ma-auto" text-xs-center v-if="workflowGroupOne.picture" xs12>
                  <v-img
                    aspect-ratio="1"
                    cover
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="workflowGroupOne.picture"
                  ></v-img>
                </v-flex>
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <!-- Other Workflow -->
      <v-layout align-center justify-center mt-4 row wrap>
        <v-flex xs12>
          <WorkflowBox :limit="10">วิธีการปลูกอื่นๆ</WorkflowBox>
        </v-flex>
      </v-layout>

      <!-- Content Searchbox -->
      <v-layout align-center justify-center row wrap>
        <v-flex text-xs-center xs11>
          <base-search-bottom-page></base-search-bottom-page>
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs11>
          <base-banners bannerPositionId="BANNERPOS0000003" pageId="PAGES0000004"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import WorkflowBox from '@/components/product_search/WorkflowBox'

export default {
  name: 'workflow',
  components: {
    WorkflowBox
  },
  data() {
    return {}
  },
  computed: {
    // all session
    productId() {
      return window.atob(this.$route.params.productId)
    },
    workflowRecordId() {
      return window.atob(this.$route.params.workflowRecordId)
    },
    // workflow record session
    workflowRecords() {
      return this.$store.getters['Workflow/getWorkflowRecords'].filter(
        item => item.idx == this.workflowRecordId
      )[0]
    },
    // workflow session
    workflows() {
      return this.$store.getters['Workflow/getWorkflows']
    },
    workflowGroupOne() {
      return this.workflows
    },
    workflowSubs() {
      return this.$store.getters['Workflow/getWorkflowSubs']
    },
    workflowGroups() {
      return this.$store.getters['Workflow/getWorkflowGroups']
    }
  },
  created() {
    window.scrollTo(0, 0)
    // this.workflowRecordId ? '' : this.$router.push({ name: 'home' })
  },
  mounted() {
    this.$store.dispatch('Workflow/fetchWorkflowRecord', this.productId)
    this.$store.dispatch('Workflow/fetchWorkflow', this.workflowRecordId)
    this.$store.dispatch('Workflow/fetchWorkflowSub', this.workflowRecordId)
    this.$store.dispatch('Workflow/fetchWorkflowGroup', this.workflowRecordId)
  }
}
</script>

<style lang="scss" scoped>
.img-parallax {
  /* Set a specific height */
  min-height: 200px;
  background-attachment: fixed;
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
}
.card-tips {
  border-radius: 8px;
  & .card-title {
    color: #ffca28;
  }
}
</style>
